export default {
  "10??CS": {
    sleroy: { firstName: "Leroy", familyName: "Salih" },
    jTom: { firstName: "Tom", familyName: "Jones" }
  }
};
